import { render, staticRenderFns } from "./ComparisonGrid.vue?vue&type=template&id=3858fa6e&scoped=true"
import script from "./ComparisonGrid.vue?vue&type=script&lang=ts"
export * from "./ComparisonGrid.vue?vue&type=script&lang=ts"
import style0 from "./ComparisonGrid.vue?vue&type=style&index=0&id=3858fa6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3858fa6e",
  null
  
)

export default component.exports